import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    margin: 0 -1.5rem;
    flex-direction: column;
    gap: 1.625rem;
`;

export const DescriptionContainer = styled.div`
    padding: 0 1.5rem;
    height: 265px;
    overflow-y: auto;
`;

export const Row = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    padding: 0 1.5rem;
    gap: 1rem;
`;
